// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes animate-skeleton{0%{transform:translateX(-100%) translateY(-50%)}to{transform:translateX(100%) translateY(-50%)}}.testing-menu{display:flex;width:720px;gap:20px;padding:5px 15px 30px 15px}.testing-menu__menu-links-box{max-width:250px;width:100%}.testing-menu__menu-links{max-width:180px;width:100%}.testing-menu__recently-completed-tests{max-width:430px;width:100%}.testing-menu__divider{margin:8px 0}", ""]);
// Exports
module.exports = exports;
